import axios from 'axios';
import { getCookie } from './cookies';

export const cancelTokenSource = axios.CancelToken.source();

const baseURL = process.env.REACT_APP_FITDOC_URL || 'https://api.fitdoc.be/webservicefitdoc/v1/';

const fitdocApi = axios.create({
    baseURL,
    cancelToken: cancelTokenSource.token,
    timeout: 10000,
    headers: {
        'X-Tenant-ID': process.env.CLARITALK_TENANT_ID,
        'Content-Type': 'application/json'
    }
});

fitdocApi.interceptors.request.use(
    (config) => {
        const token = getCookie('fitdoc-token')
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add a response interceptor to handle 401 Unauthorized responses
fitdocApi.interceptors.response.use(
    (response) => response,
    (error) => {
        if (axios.isCancel(error)) {
            // This handles the case when the request was canceled
            console.log('Request canceled', error.message);
            return null;
        }
        if (error.response && error.response.status === 401) {
            window.location.href = '/login'; // Redirect to login page
        }
        return Promise.reject(error);
    }
);

export default fitdocApi;